import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useTranslation } from "../../contexts/TranslationContext";

const RepaymentCard = ({

  title,
  img, // Now accepting an SVG element instead of an icon
  description,
}) => {
  const { language } = useTranslation(); // Get the current language and its properties

  return (
    <div className="px-2 md:px-4 flex-1 py-3 md:py-6 bg-white shadow-[0_4px_39px_0_rgba(81,69,159,0.08)] rounded-[14px]">
      {/* Mobile layout - icon left, title and amount stacked right */}
      <div className="flex md:hidden gap-3 items-start">
        <div className="w-7 h-7 flex-shrink-0 flex justify-center items-center rounded-full bg-[#006E7E14]">
          <img src={img} alt="Contracted Amount" className="w-3 h-3" />
        </div>
        <div className="flex flex-col gap-1">
          <p className="font-normal text-[12px] text-[#14213D]">{title}</p>
          <div className="flex gap-1 items-center font-medium text-[#1D1E25] text-sm"> 
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="16"
              className="flex-shrink-0"
              fill="none"
              viewBox="0 0 17 19"
            >
              <path
                fill="#000"
                d="M16.965 15.49c-.112.906-.162 1.299-.58 2.183L9.956 19c.148-.955.345-1.692.665-2.134zM8.01 9.236l1.92-.417V2.75c.716-.804 1.157-1.165 2.021-1.621V8.38l5.014-1.088c-.112.907-.162 1.3-.58 2.184l-4.434.936v2.04l5.014-1.061c-.112.906-.162 1.3-.58 2.183l-4.434.915v.02l-2.02.417V10.84l-1.921.406v2.575l-.032.006a19.6 19.6 0 0 1-1.667 2.45L0 17.477c.057-.811.175-1.269.542-2.086L5.99 14.21v-2.537L.94 12.742c.057-.812.175-1.269.542-2.087l4.508-.98V1.62C6.706.817 7.146.456 8.01 0z"
              ></path>
            </svg>
            <span>{description ? description : 0}</span>
          </div>
        </div>
      </div>

      {/* Desktop layout - original design */}
      <div className="hidden md:flex flex-col">
        <div className="flex justify-between mb-2 items-center">
          <p className="font-normal text-base text-[#14213D]">{title}</p>
          <div className="w-12 h-12 flex justify-center items-center rounded-full bg-[#006E7E14]">
            <img src={img} alt="Contracted Amount" />
          </div>
        </div>
        <p className="flex gap-2 items-center flex-wrap font-medium text-[#1D1E25] text-xl"> 
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="19"
            fill="none"
            viewBox="0 0 17 19"
          >
            <path
              fill="#000"
              d="M16.965 15.49c-.112.906-.162 1.299-.58 2.183L9.956 19c.148-.955.345-1.692.665-2.134zM8.01 9.236l1.92-.417V2.75c.716-.804 1.157-1.165 2.021-1.621V8.38l5.014-1.088c-.112.907-.162 1.3-.58 2.184l-4.434.936v2.04l5.014-1.061c-.112.906-.162 1.3-.58 2.183l-4.434.915v.02l-2.02.417V10.84l-1.921.406v2.575l-.032.006a19.6 19.6 0 0 1-1.667 2.45L0 17.477c.057-.811.175-1.269.542-2.086L5.99 14.21v-2.537L.94 12.742c.057-.812.175-1.269.542-2.087l4.508-.98V1.62C6.706.817 7.146.456 8.01 0z"
            ></path>
          </svg>
          {description ? description : 0}
        </p>
      </div>

    </div>
  );
};

export default RepaymentCard;
